export const shellHeight = 50;